import { ToModeType } from '@touchvue/utils'
import { PropType } from 'vue'

export interface IconObject {
	value?: string
	[key: string]: any
}

export type ButtonType = 'default' | 'primary' | 'success' | 'info' | 'warning' | 'danger'

export type ButtonIconPosition = 'left' | 'top'

export interface ButtonProps {
	progress?: number | string
	width?: string | number
	icon?: string | IconObject
	iconPosition?: ButtonIconPosition
	loading?: boolean
	disabled?: boolean
	shadow?: boolean
	color?: string
	mode?: ToModeType
	type?: ButtonType
	desc?: string
}

export const buttonProps = {
	progress: {
		type: [Number, String],
		default: ''
	},
	width: {
		type: [String, Number],
		default: ''
	},
	icon: {
		type: [String, Object],
		default: ''
	},
	iconPosition: {
		type: String,
		default: 'left'
	},
	loading: {
		type: Boolean,
		default: false
	},
	disabled: {
		type: Boolean,
		default: false
	},
	shadow: {
		type: Boolean,
		default: false
	},
	color: {
		type: String,
		default: 'default'
	},
	mode: {
		type: String as PropType<ToModeType>,
		default: 'fill'
	},
	type: {
		type: String as PropType<ButtonType>,
		default: 'default'
	},
	desc: {
		type: String,
		default: ''
	}
}
